import {
  getAdsWithCreativesLoading,
  getAdsWithCreativesSuccess,
  getAdsWithCreativesFailure,
  updateCreativeGroupsLoading,
  updateCreativeGroupsSuccess,
  updateCreativeGroupsFailure,
  searchLandingPagesLoading,
  searchLandingPagesSuccess,
  searchLandingPagesFailure,
  clearSearchResults,
  updateAdLoading,
  updateAdSuccess,
  updateAdFailure,
} from "@redux/slices/adsSlice.js"
import { getAdsWithCreatives } from "@services/ads/getAdsWithCreatives.js"
import { useDispatch } from "react-redux"
import { updateCreativeGroups } from "@services/ads/updateCreativeGroups"
import { searchLandingPages } from "@services/ads/searchLandingPages"
import { updateAd } from "@services/ads/updateAd.js"

//const userId = import.meta.env.VITE_USER_ID

const useAds = () => {
  const userId = localStorage.getItem("userId")
  const dispatch = useDispatch()

  const handleGetAdsWithCreatives = async (userId, folderId) => {
    try {
      dispatch(getAdsWithCreativesLoading())
      const response = await getAdsWithCreatives(userId, folderId)
      dispatch(getAdsWithCreativesSuccess(response.data.data))
    } catch (error) {
      dispatch(getAdsWithCreativesFailure())
      console.log(error)
    }
  }

  const handleUpdateCreativeGroups = async (updates) => {
    try {
      dispatch(updateCreativeGroupsLoading())
      await updateCreativeGroups(updates)
      dispatch(updateCreativeGroupsSuccess())
    } catch (error) {
      dispatch(updateCreativeGroupsFailure())
      console.error("Error updating creative groups:", error)
    }
  }

  const handleUpdateAd = async (adId, data) => {
    try {
      dispatch(updateAdLoading())
      const response = await updateAd(adId, data)
      // handleGetAdsWithCreatives(userId)
      dispatch(updateAdSuccess(response.data.data))
    } catch (error) {
      dispatch(updateAdFailure())
      console.error("Error updating ad:", error)
    }
  }

  const handleSearchLandingPages = async (query) => {
    try {
      if (!query?.trim()) {
        dispatch(clearSearchResults())
        return
      }

      dispatch(searchLandingPagesLoading())
      const response = await searchLandingPages(query)
      dispatch(searchLandingPagesSuccess(response.data.data))
    } catch (error) {
      dispatch(searchLandingPagesFailure())
      console.error("Error searching landing pages:", error)
    }
  }

  const handleClearSearchResults = () => {
    dispatch(clearSearchResults())
  }

  return {
    handleGetAdsWithCreatives,
    handleUpdateCreativeGroups,
    handleSearchLandingPages,
    handleClearSearchResults,
    handleUpdateAd,
  }
}

export default useAds
